import { render, staticRenderFns } from "./T3Start.vue?vue&type=template&id=6527f4a4"
import script from "./T3Start.vue?vue&type=script&lang=ts"
export * from "./T3Start.vue?vue&type=script&lang=ts"
import style0 from "./T3Start.vue?vue&type=style&index=0&id=6527f4a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports